import dayjs from "dayjs"
import customParseFormat from "dayjs/plugin/customParseFormat"

dayjs.extend(customParseFormat)

export function getAge(dateString, interval = 10) {
    var today = new Date()
    var birthDate = new Date(dateString)
    var age = today.getFullYear() - birthDate.getFullYear()
    var m = today.getMonth() - birthDate.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--
    }
    return age
}

export function isSameSlot(s1, s2) {
    const isSame = (field) => s1[field] === s2[field]
    const c1 = isSame("date")
    const c2 = isSame("window")
    const c3 = isSame("locationCode")
    return [c1, c2, c3].every(Boolean)
}

export function getDaySlots(
    date,
    startTime,
    endTime,
    locationCode,
    duration = 10
) {
    const start = dayjs(startTime, "HH:mm")
    const end = dayjs(endTime, "HH:mm")
    let current = start
    const slots = []

    while (end.isAfter(current, "minute")) {
        const slotEnd = dayjs(current).add(duration, "minutes")
        if (slotEnd.isBefore(end, "minute") || slotEnd.isSame(end, "minute")) {
            slots.push({
                tempId: `${Math.random()}`,
                visible: true,
                note: "",
                date,
                locationCode,
                booker: null,
                window: `${current.format("HH:mm")} - ${slotEnd.format(
                    "HH:mm"
                )}`,
            })
        }
        current = dayjs(slotEnd)
    }

    return slots
}

export function uniqueFilter(value, index, self) {
    return self.indexOf(value) === index
}
